import { DateRange } from "@/store/statisticsPeriodStore";
import { RegistrationsSeries } from "@/types/statistics";
import {
  addDays,
  daysInRange,
  formatDayMonth,
  formatTiny,
  startOfDay,
} from "@/components/PeriodSelector/periodDates";

const BUCKETS_COUNT = 7;

export interface ChartBuckets {
  // подписи оси X; пустая строка — интервал за пределами периода
  labels: string[];
  // заголовки подсказки: «12 августа» или «12 августа — 16 августа»
  tips: string[];
  series: (Omit<RegistrationsSeries, "points"> & { values: number[] })[];
}

// период делим на 7 равных интервалов: короткий — по дню, длинный — по несколько дней
export const buildChartBuckets = (
  { from, to }: DateRange,
  series: RegistrationsSeries[]
): ChartBuckets => {
  const size = Math.max(1, Math.ceil(daysInRange(from, to) / BUCKETS_COUNT));
  const labels: string[] = [];
  const tips: string[] = [];
  const bounds: (DateRange | null)[] = [];

  for (let i = 0; i < BUCKETS_COUNT; i++) {
    const start = addDays(from, i * size);
    if (start > to) {
      labels.push("");
      tips.push("");
      bounds.push(null);
      continue;
    }
    const endCandidate = addDays(start, size - 1);
    const end = endCandidate > to ? to : endCandidate;

    labels.push(size === 1 ? String(start.getDate()) : formatTiny(start));
    tips.push(
      start.getTime() === end.getTime()
        ? formatDayMonth(start)
        : `${formatDayMonth(start)} — ${formatDayMonth(end)}`
    );
    bounds.push({ from: start, to: end });
  }

  return {
    labels,
    tips,
    series: series.map(({ points, ...rest }) => ({
      ...rest,
      values: bounds.map((bound) => {
        if (!bound) return 0;
        return points.reduce((acc, point) => {
          const day = startOfDay(point.date);
          const inBucket = day >= bound.from && day <= bound.to;
          return inBucket ? acc + point.value : acc;
        }, 0);
      }),
    })),
  };
};
